import styled from 'styled-components';

interface IToggleContainer {
  active: boolean;
}

export const ToggleContainer = styled.div<IToggleContainer>`
  width: 28px;
  min-width: 28px;
  cursor: pointer;
  user-select: none;
  border-radius: 8px;
  height: 16px;
  position: relative;
  background: ${({ active }) => (active ? '#1371FE' : '#d8dae5')};
`;

interface IDialogButton {
  active: boolean;
}

export const DialogButton = styled.div<IDialogButton>`
  font-size: 14px;
  line-height: 16px;
  font-weight: bold;
  cursor: pointer;
  background-color: #fff;
  color: white;
  border-radius: 18px;
  min-width: 46px;
  width: 12px;
  height: 12px;
  min-width: unset;
  border-radius: 6px;
  position: absolute;
  left: ${({ active }) => (active ? '14px' : '2px')};
  top: 2px;
  transition: all 0.3s ease;
`;
